/// <amd-module name="Search/Shared/Base/Sources/ResultsCountSource" />
import * as Rest_Client from "Search/LegacyWebApi/RestClient/Search";
import { IVssPageContext } from "VSS/Platform/Context";
import * as VSS_Trace from "VSS/Platform/Trace";
import { getTFSPageData, IProjectData } from "Tfs/Platform/Page";
import { CountRequest, CountResponse, RelationFromExactCount } from "Search/LegacyWebApi/Contracts/Search.SharedLegacy";
import { SEARCH_AREA } from "Search/Shared/CustomerIntelligenceConstants";

/**
* Source for fetching search results count for a specific entity
**/
export class ResultsCountSource {
    private searchClient: Rest_Client.ISearchRestClient;
    private project: IProjectData | undefined;

    constructor(private pageContext: IVssPageContext) {
        this.searchClient = pageContext.getRestClient<Rest_Client.ISearchRestClient>("Legacy.ISearchRestClient");
        this.project = getTFSPageData(pageContext)!.project;
    }

    public getResultCounts = (
        entityIds: string[],
        searchText: string
    ): Promise<{ id: string, count: number, relationFromExactCount: RelationFromExactCount }[]> => {
        // set project filter if search is in project context
        const searchFilters: { [key: string]: string[] } = {};

        if (this.project) {
            searchFilters["Projects"] = [this.project.name];
        }

        const countRequest: CountRequest = { searchFilters, searchText };
        const resultCountPromises =
            entityIds
                .map(entityId =>
                    this.getEntityResultCount(countRequest, entityId)
                        .then(countResponse => {
                            return {
                                id: entityId,
                                count: countResponse.count,
                                relationFromExactCount: countResponse.relationFromExactCount
                            }
                        }, error => {
                            // Adding client trace entry
                            VSS_Trace.traceError(
                                this.pageContext,
                                SEARCH_AREA,
                                "Search.Shared.Base.Sources.ResultsCountSource.GetResultCounts.Failed",
                                error.message,
                                { error: error }
                            );

                            // Return zero results count
                            return {
                                id: entityId,
                                count: 0,
                                relationFromExactCount: 0
                            };
                        }));

        return Promise.all(resultCountPromises);
    }

    private getEntityResultCount = (countRequest: CountRequest, entityType: string): Promise<CountResponse> => {
        return this.searchClient.resultsCount(countRequest, entityType, this.project && this.project.id);
    }
}
